







































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import '../../assets/css/AccountSetup.scss';
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';
import { MapUtils } from '../../util/mapUtils';
import { ProfileRequest, Address } from '../../types/request';
import { MedTransGoConstants } from '../../util/constants';
import { ObjectFactory } from '../../config/objectFactory';
import MessageBox from '../../components/MessageBox.vue';
import DocumentModal from './DocumentModal.vue';
import { CommonUtils } from '@/util/commonUtils';
import { EventBus } from '@/main';
import { ToastEvent } from '@/types/event';
declare var google: any;
@Component({
    mixins: [validationMixin],
    components: {
        MessageBox,
        DocumentModal,
    },
    computed: {
        roleOptions() {
            const options = [
            ];
            const sessionInfo = ObjectFactory.getCacheService().getSessionInfo();
            if (sessionInfo.scopes.includes('transporter')) {
                options.push({ text: 'First Responder', value: 'FIRST_RESPONDER' });
                options.push({ text: 'NEMT Transporter', value: 'NEMT' });
                options.push({ text: 'EMS Transporter', value: 'EMS' });
            }
            if (sessionInfo.scopes.includes('homeHealthCare')) {
                options.push({ text: 'CNA (Certified Nursing Assistant)', value: 'CNA' });
                options.push({ text: 'RN (Registered Nursing)', value: 'RN' });
            }
            return options;
        },
        sourceDetailsQuestion() {
            switch (this.$props.request.sourceAnswer) {
                case 'Search Engine':
                    return 'Which search engine?';
                case 'Social Media':
                    return 'Which social media?';
                case 'Referral':
                    return 'From which source?';
                case 'Event':
                    return 'Which type of event?';
                case 'Advertisement':
                    return 'From which source?';
                case 'Outreach from MedTrans Go Team':
                    return 'From which source?';
                default:
                    return '';
            }
        },
    },
    props: {
        request: Object,
    },
    data() {
        return {
            selectedSecondaryOption: '',
        };
    },
    validations() {
        const validations = {
            request: {
                address: {
                    fullAddress: {
                        required,
                    },
                    state: {
                        required,
                    },
                    city: {
                        required,
                    },
                    zip: {
                        required,
                    },
                    locality: {},
                },
                companyName: {
                    required,
                },
                roles: {
                    required,
                },
                fullname: {
                    required,
                },
                email: {
                    email,
                    required,
                },
                phone: {
                    required,
                },
                title: {
                    required,
                },
                companyPhoneNumber: {
                    required,
                },
                companyTaxId: {
                    required,
                },
                companyWebsite: {
                },
                hasAdditionalLocation: {
                    required,
                },
                locations: {
                    $each: {
                        branchName: {
                            required,
                        },
                        phone: {
                            required,
                        },
                        email: {
                            required,
                        },
                        locationAddress: {
                            fullAddress: {
                                required,
                            },
                            state: {
                                required,
                            },
                            city: {
                                required,
                            },
                            zip: {
                                required,
                            },
                            locality: {},
                        },
                    },
                },
                users: {
                    $each: {
                        fullName: {
                            required,
                        },
                        phone: {
                            required,
                        },
                        title: {
                            required,
                        },
                        email: {
                            required,
                        },
                        address: {
                            fullAddress: {
                                required,
                            },
                            state: {
                                required,
                            },
                            city: {
                                required,
                            },
                            zip: {
                                required,
                            },
                            locality: {},
                        },
                    },
                },
                sourceAnswer: {
                    required,
                },
                sourceDetailsAnswer: {
                    required,
                },
            },
        };
        const personalInfo = this as PersonalInfo;
        if (!personalInfo.sessionInfo.scopes.includes('transporter') && !personalInfo.sessionInfo.scopes.includes('homeHealthCare')) {
            delete validations.request.companyName;
            delete validations.request.roles;
            delete validations.request.companyPhoneNumber;
            delete validations.request.companyTaxId;
            delete validations.request.companyWebsite;
            delete validations.request.hasAdditionalLocation;
            delete validations.request.locations;
            delete validations.request.users;
            delete validations.request.title;
        }
        if (!personalInfo.sessionInfo.scopes.includes('transporter') && personalInfo.sessionInfo.scopes.includes('homeHealthCare')) {
            delete validations.request.companyPhoneNumber;
            delete validations.request.companyTaxId;
            delete validations.request.companyWebsite;
            delete validations.request.hasAdditionalLocation;
            delete validations.request.locations;
            delete validations.request.users;
            delete validations.request.title;
        }
        return validations;
    },
})
export default class PersonalInfo extends Vue {

    private interpreterGoogleAddress: any;
    private show = false;
    private showDocumentModal = false;
    private sessionInfo = ObjectFactory.getCacheService().getSessionInfo();
    private secondaryOptions: string[] = [];
    public mounted() {
        if (this.$v) {
            this.$v.$touch();
        }
        this.interpreterGoogleAddress = new google.maps.places.Autocomplete(this.$refs.interpreterAddress,
            { types: ['geocode'] });
        this.interpreterGoogleAddress.addListener('place_changed', () => {
            this.$props.request.address = MapUtils.parseGoogleAddress(this.interpreterGoogleAddress);
        });
        this.show = true;
        if (this.sessionInfo.scopes.includes('transporter') && !sessionStorage.getItem('showDocumentModal')) {
            this.showDocumentModal = true;
        }
        // this.$props.request.isStep1Valid = !this.$v.$invalid;
        this.$props.request.isStepPIValid = false;
        this.$props.request.isStepUCValid = false;
        this.$props.request.isStepUDValid = false;
        this.$props.request.isStepQnValid = false;
        this.$props.request.isStepHIValid = false;
        this.$props.request.isStepADValid = false;
        this.$data.selectedSecondaryOption = this.$props.request.sourceDetailsAnswer;
        if (this.$props.request && this.$props.request.sourceAnswer) {
            this.$data.selectedSecondaryOption = this.$props.request.sourceDetailsAnswer;
            this.getSubQuestion();
        }
    }
    private addUser() {
        if (this.$props.request.users && this.$props.request.users.length < 2) {
            this.$props.request.users.push({
                fullName: '', title: '', email: '', phone: '',
                address: { fullAddress: '' },
            });
            const index = this.$props.request.users.length - 1;
            setTimeout(() => {
                const fieldName = `user${index}`;
                const ref = this.$refs[fieldName] as any;
                const googleAddress = new google.maps.places.Autocomplete(ref[0],
                    { types: ['geocode'] });
                googleAddress.addListener('place_changed', () => {
                    this.$props.request.users[index].address = MapUtils.parseGoogleAddress(googleAddress);
                });
            });
        }
    }

    private removeUser() {
        if (this.$props.request.users && this.$props.request.users.length) {
            this.$props.request.users.splice(this.$props.request.users.length - 1, 1);
        }
    }

    private addLocation() {
        if (this.$props.request.locations && this.$props.request.locations.length < 2) {
            this.$props.request.locations.push({ branchName: '', phone: '', email: '', locationAddress: { fullAddress: '' } });
            const index = this.$props.request.locations.length - 1;
            setTimeout(() => {
                const fieldName = `location${index}`;
                const ref = this.$refs[fieldName] as any;
                const googleAddress = new google.maps.places.Autocomplete(ref[0],
                    { types: ['geocode'] });
                googleAddress.addListener('place_changed', () => {
                    this.$props.request.locations[index].locationAddress = MapUtils.parseGoogleAddress(googleAddress);
                });
            });
        }
        if (this.$v) {
            this.$v.$touch();
        }
    }

    private removeLocation() {
        if (this.$props.request.locations && this.$props.request.locations.length) {
            this.$props.request.locations.splice(this.$props.request.locations.length - 1, 1);
        }
    }

    private async save() {
        const profileRequest: ProfileRequest = this.$props.request;
        const address = profileRequest.address as Address;
        if (address.country !== 'United States') {
            const messageBox: any = this.$refs.messageBox;
            messageBox.showModal();
            return;
        }
        const partnerService = ObjectFactory.getPartnerService();
        const updateProfileResponse = await partnerService.updateUserProfile({
            email: profileRequest.email,
            fullname: profileRequest.fullname,
            phone: profileRequest.phone,
        }, this.$store.state.serverUrl);
        if (updateProfileResponse.success) {
            if (this.sessionInfo.scopes.includes('interpreter') &&
                profileRequest.updatePartnerProfileRequest.interpreterProfile) {
                profileRequest.updatePartnerProfileRequest.interpreterProfile.referralSource =
                    `${profileRequest.sourceAnswer}-${profileRequest.sourceDetailsAnswer}` as any;
                profileRequest.updatePartnerProfileRequest.interpreterProfile.referralSource =
                    profileRequest.sourceAnswer;
                if (profileRequest.updatePartnerProfileRequest.interpreterProfile.referralSource
                    && profileRequest.sourceDetailsAnswer) {
                    profileRequest.updatePartnerProfileRequest.interpreterProfile.referralSource +=
                        `-${profileRequest.sourceDetailsAnswer}`;
                }
                profileRequest.updatePartnerProfileRequest.interpreterProfile.address = this.$props.request.address;
                profileRequest.updatePartnerProfileRequest.interpreterProfile.fullname = this.$props.request.fullname;
                profileRequest.updatePartnerProfileRequest.interpreterProfile.phone = this.$props.request.phone;
            }
            if (this.sessionInfo.scopes.includes('transporter') &&
                profileRequest.updatePartnerProfileRequest.transporterProfile) {
                if (profileRequest.roles) {
                    const transporterRoles = ['FIRST_RESPONDER', 'NEMT', 'EMS'];
                    profileRequest.updatePartnerProfileRequest.
                        transporterProfile.roles = [];
                    profileRequest.roles.forEach((element) => {
                        if (profileRequest.roles && profileRequest.updatePartnerProfileRequest.
                            transporterProfile && profileRequest.updatePartnerProfileRequest.
                                transporterProfile.roles) {
                            if (transporterRoles.includes(element)) {
                                profileRequest.updatePartnerProfileRequest.
                                    transporterProfile.roles.push(element);
                            }
                        }
                    });
                    if (!profileRequest.updatePartnerProfileRequest.
                        transporterProfile.roles.length) {
                        const toastEvent: ToastEvent = {
                            message: 'Please select one of the transportation role',
                            title: 'Error!',
                            timeout: 5000,
                            varient: 'danger',
                        };
                        EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
                        return;
                    }
                }
                profileRequest.updatePartnerProfileRequest.transporterProfile.referralSource =
                    `${profileRequest.sourceAnswer}-${profileRequest.sourceDetailsAnswer}` as any;
                profileRequest.updatePartnerProfileRequest.transporterProfile.address = this.$props.request.address;
                profileRequest.updatePartnerProfileRequest.
                    transporterProfile.companyName = this.$props.request.companyName;
                profileRequest.updatePartnerProfileRequest.transporterProfile.referralSource =
                    profileRequest.sourceAnswer;
                profileRequest.updatePartnerProfileRequest.
                    transporterProfile.companyTaxId = this.$props.request.companyTaxId;
                profileRequest.updatePartnerProfileRequest.
                    transporterProfile.companyPhoneNumber = this.$props.request.companyPhoneNumber;
                profileRequest.updatePartnerProfileRequest.
                    transporterProfile.companyWebsite = this.$props.request.companyWebsite;
                profileRequest.updatePartnerProfileRequest.transporterProfile.title = this.$props.request.title;
                profileRequest.updatePartnerProfileRequest.transporterProfile.users = this.$props.request.users;
                profileRequest.updatePartnerProfileRequest.transporterProfile.locations = this.$props.request.locations;
                if (profileRequest.updatePartnerProfileRequest.transporterProfile.referralSource
                    && profileRequest.sourceDetailsAnswer) {
                    profileRequest.updatePartnerProfileRequest.transporterProfile.referralSource += `-${profileRequest.sourceDetailsAnswer}`;
                }
            }
            if (this.sessionInfo.scopes.includes('homeHealthCare') &&
                profileRequest.updatePartnerProfileRequest.homeHealthCareProfile) {
                profileRequest.updatePartnerProfileRequest.homeHealthCareProfile.referralSource =
                    `${profileRequest.sourceAnswer}-${profileRequest.sourceDetailsAnswer}` as any;
                profileRequest.updatePartnerProfileRequest.homeHealthCareProfile.address = this.$props.request.address;
                profileRequest.updatePartnerProfileRequest.
                    homeHealthCareProfile.companyName = this.$props.request.companyName;
                if (profileRequest.roles) {
                    const homeHealthCareRoles = ['CNA', 'RN'];
                    profileRequest.updatePartnerProfileRequest.
                        homeHealthCareProfile.roles = [];
                    profileRequest.roles.forEach((element) => {
                        if (profileRequest.roles && profileRequest.updatePartnerProfileRequest.
                            homeHealthCareProfile && profileRequest.updatePartnerProfileRequest.
                                homeHealthCareProfile.roles) {
                            if (homeHealthCareRoles.includes(element)) {
                                profileRequest.updatePartnerProfileRequest.
                                    homeHealthCareProfile.roles.push(element);
                            }
                        }
                    });
                    if (!profileRequest.updatePartnerProfileRequest.
                        homeHealthCareProfile.roles.length) {
                        const toastEvent: ToastEvent = {
                            message: 'Please select one of the home healthcare role',
                            title: 'Error!',
                            timeout: 5000,
                            varient: 'danger',
                        };
                        EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
                        return;
                    }
                }
                profileRequest.updatePartnerProfileRequest.homeHealthCareProfile.referralSource =
                    profileRequest.sourceAnswer;
                if (profileRequest.updatePartnerProfileRequest.homeHealthCareProfile.referralSource
                    && profileRequest.sourceDetailsAnswer) {
                    profileRequest.updatePartnerProfileRequest.homeHealthCareProfile.referralSource += `-${profileRequest.sourceDetailsAnswer}`;
                }
            }
            const updatePartnerProfileResponse = await partnerService
                .updatePartnerProfile(profileRequest.updatePartnerProfileRequest, this.$store.state.serverUrl);
            if (updatePartnerProfileResponse.success) {
                if (this.sessionInfo.scopes.includes('transporter') ||
                    this.sessionInfo.scopes.includes('homeHealthCare')) {
                    this.$router.push({ name: MedTransGoConstants.VIEW_TRANSPORTATION_QUESTIONNAIRE_NAME });
                } else {
                    this.$router.push({ name: MedTransGoConstants.VIEW_UPLOAD_CERTIFICATE_NAME });
                }
                profileRequest.isStepPIValid = true;
            }
        }
    }

    private logout() {
        CommonUtils.logout(this.$store.state);
    }
    private closeDocumentModal() {
        this.showDocumentModal = false;
        sessionStorage.setItem('showDocumentModal', 'true');
    }
    private maskPhone(phone: string) {
        return CommonUtils.phoneNumberMask(phone);
    }
    private getSubQuestion() {
        const profileRequest: ProfileRequest = this.$props.request;
        const sourceAnswer = profileRequest.sourceAnswer;
        switch (sourceAnswer) {
            case 'Search Engine':
                this.secondaryOptions = ['Google', 'Bing', 'Other'];
                break;
            case 'Social Media':
                this.secondaryOptions = ['LinkedIn', 'Instagram', 'Facebook', 'YouTube', 'Other'];
                break;
            case 'Referral':
                this.secondaryOptions = ['MedTrans Go Team', 'An association', 'Another transporter or interpreter', 'Other'];
                break;
            case 'Event':
                this.secondaryOptions = ['In-Person', 'Virtual'];
                break;
            case 'Advertisement':
                this.secondaryOptions = ['Mailer', 'Digital Ad', 'Flyer', 'TV/Radio', 'Billboard', 'Other'];
                break;
            case 'Outreach from MedTrans Go Team':
                this.secondaryOptions = ['Phone Call', 'Email'];
                break;
             default:
                this.secondaryOptions = [];
                break;
        }
    }
    private handleSecondaryOptionChange() {
        this.$props.request.sourceDetailsAnswer = this.$data.selectedSecondaryOption;
    }

    private handlerSourceAnswerChange() {
        this.$props.request.sourceDetailsAnswer = '';
        this.$data.selectedSecondaryOption = '';
    }
}
